import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/TISSA-LogoWithTagline.png';
import './Header.css';
const NAV_ITEMS = [
  { label: 'Home',         path: '/',            dropdown: false },
  { label: 'Services',     path: '/services',    dropdown: false },
  { label: 'Solutions',    path: '/solutions',   dropdown: false },
  { label: 'Industries',   path: '/industries',  dropdown: false },
  { label: 'Accelerators', path: '/accelerators', dropdown: false },
  { label: 'Case Studies', path: '/case-studies', dropdown: false },
  { label: 'Insights',     path: '/insights',    dropdown: false },
  { label: 'Careers',      path: '/careers',     dropdown: false },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <header className={`site-header ${scrolled ? 'scrolled' : ''}`}>
      {/* Top contact bar */}
      <div className="top-contact-bar">
        <div className="top-contact-inner">
          <a href="tel:+15122037627" className="top-contact-item">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.37 2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.56a16 16 0 0 0 5.95 5.95l.95-.95a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            +1-512-203-7627
          </a>
          <a href="mailto:connect@tissatech.com" className="top-contact-item">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            connect@tissatech.com
          </a>
        </div>
      </div>

      <div className="container navbar">
        <Link className="brand" to="/">
          <div className="brand-logo-block">
            <img src={logo} alt="TISSA Technology logo" />
          </div>
        </Link>

        {/* Desktop nav */}
        <nav className="navlinks">
          {NAV_ITEMS.map(({ label, path, dropdown }) => (
            <Link
              key={path}
              to={path}
              className={`nav-link ${location.pathname === path ? 'active' : ''}`}
            >
              {label}
              {dropdown && (
                <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none">
                  <path d="M1 1l4 4 4-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </Link>
          ))}
          <Link className="btn btn-contact" to="/contact"><span>Contact Us</span></Link>
        </nav>

        <button
          className="mobile-menu"
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(o => !o)}
        >
          {menuOpen ? '✕' : '☰'}
        </button>
      </div>

      {/* Mobile nav — in document flow, no overlap */}
      {menuOpen && (
        <nav className="mobile-nav" aria-label="Mobile navigation">
          <div className="container">
            {NAV_ITEMS.map(({ label, path, dropdown }) => (
              <Link
                key={path}
                to={path}
                className={`nav-link ${location.pathname === path ? 'active' : ''}`}
              >
                {label}
                {dropdown && (
                  <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none">
                    <path d="M1 1l4 4 4-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                )}
              </Link>
            ))}
            <Link className="btn btn-contact mobile-contact" to="/contact"><span>Contact Us</span></Link>
          </div>
        </nav>
      )}
    </header>
  );
}
